export default __webpack_public_path__ + "static/media/help.aed07aa1.svg";